import "./FooterBody.css";
import { openingHours } from "../../constants";

function FooterBody() {
    const year = new Date().getFullYear();
    const phoneNumber = "+14794129916";
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent("Hello, I would like to know more about your services")}`;

    return (
        <footer className="footerBody">
            <div className="footer__grid">
                {/* About */}
                <div className="footer__col">
                    <h4 className="footer__heading">About Desi Bites</h4>
                    <p className="footer__text">
                        Desi Bites rolled onto the streets in 2024, bringing a vibrant taste of India to the neighborhood. With every bite, we serve up the rich, flavorful comfort of Indian cuisine, transforming traditional street food into something truly unforgettable.
                    </p>
                </div>

                {/* Hours */}
                <div className="footer__col hours" id="store-hours-section">
                    <h4 className="footer__heading">Opening Hours</h4>
                    <div className="footer__hours-list">
                        {openingHours.map((day, index) => (
                            <div key={index} className="footer__hours-row">
                                <span>{day.day}</span>
                                <span className="footer__hours-time">{day.hours}</span>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Connect */}
                <div className="footer__col">
                    <h4 className="footer__heading">Connect</h4>
                    <div className="footer__links">
                        <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="footer__link-row">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"/></svg>
                            WhatsApp
                        </a>
                        <a href={`tel:${phoneNumber}`} className="footer__link-row">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>
                            (479) 412-9916
                        </a>
                        <a href="mailto:desibitesnwa@gmail.com" className="footer__link-row">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                            desibitesnwa@gmail.com
                        </a>
                        <div className="footer__social">
                            <a href="https://www.instagram.com/desibitesnwa?igsh=MWdyYTFmNDV6d2V3ZA==" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="footer__social-icon">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="2" width="20" height="20" rx="5"/><path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
                            </a>
                            <a href="https://m.facebook.com/desibitesnwa/" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="footer__social-icon">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/></svg>
                            </a>
                            <a href="https://www.doordash.com/store/desi-bites-centerton-31061357" target="_blank" rel="noopener noreferrer" aria-label="DoorDash" className="footer__social-icon">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 17H4a2 2 0 01-2-2V5a2 2 0 012-2h16a2 2 0 012 2v10a2 2 0 01-2 2h-1"/><polygon points="12 15 17 21 7 21 12 15"/></svg>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Copyright */}
            <div className="footer__bottom">
                <p>&copy; {year} Desi Bites. All rights reserved.</p>
                <p>Developed by <span className="footer__dev">Rama krishna komma</span></p>
            </div>
        </footer>
    );
}

export default FooterBody;
